import { useEffect, useRef } from 'react'
import JsonView from 'react18-json-view'
import { ItemDataTypes, Product } from 'store/types'
import 'react18-json-view/src/style.css'
import CircleCheckSolidIcon from 'atoms/icons/CircleCheckSolidIcon'
import { createText } from 'store/factory'

type Props = {
  product: Product
  open: boolean
  onClose: () => void
  onConfirm: (newItem: ItemDataTypes) => void
}

function SelectButton({ onClick }: { onClick?: (event: React.MouseEvent) => void }) {
  return (
    <span className='inline-block rounded-full cursor-pointer text-success ml-1' onClick={onClick}>
      <CircleCheckSolidIcon size={12} />
    </span>
  )
}

function CopyComponent({ onClick }: { onClick: (event: React.MouseEvent) => void; className: string }) {
  return <SelectButton onClick={onClick} />
}

function CopiedComponent() {
  return <SelectButton />
}

function ProductInfoModal({ product, open, onClose, onConfirm }: Props) {
  const ref = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (!ref.current) return
    if (open) {
      ref.current.showModal()
    } else {
      ref.current.close()
    }
  }, [open])

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  return (
    <>
      <dialog
        ref={ref}
        id='product-info-modal'
        className='modal'
        onCancel={e => {
          e.preventDefault()
          handleClose()
        }}>
        <div className='modal-box max-w-full flex flex-col'>
          <h3 className='font-bold text-lg pb-4'>{product.item_identification_name}</h3>
          <div className='flex-1 overflow-auto'>
            <JsonView
              src={product}
              CopyComponent={CopyComponent}
              customizeCopy={node => {
                if (typeof node === 'object') return
                // TODO: improve that later to get other type of items
                const newItem = createText()
                newItem.props.text = typeof node === 'string' ? node : JSON.stringify(node)
                onConfirm(newItem)
              }}
              CopiedComponent={CopiedComponent}
            />
          </div>
          <div className='modal-action'>
            <form className='flex gap-2' method='dialog'>
              <button className='btn' onClick={handleClose}>
                Cancelar
              </button>
            </form>
          </div>
        </div>
        <label className='modal-backdrop' htmlFor='product-info-modal' onClick={handleClose}>
          Cancelar
        </label>
      </dialog>
    </>
  )
}

export default ProductInfoModal
